import makeRequest from './client';

const baseURL = `/active-ingredients`;

export const getAllActiveIngredients = () => {
  const finalURL = `${baseURL}/all`;
  return makeRequest(finalURL, 'GET');
};

export const getActiveIngredient = (id: string) => {
  const finalURL = `${baseURL}/all/${id}`;
  return makeRequest(finalURL, 'GET');
};

export const getActiveIngredientDocuments = (source: string, applicationNumber: string) => {
  const finalURL = `${baseURL}/documents/${source}/${applicationNumber}`;
  return makeRequest(finalURL, 'GET');
};

export const validateActiveIngredientTrials = (payload: any) => {
  const finalURL = `${baseURL}/validate`;
  return makeRequest(finalURL, 'POST', payload);
};

export const submitCommonNames = (payload: any) => {
  const finalURL = `${baseURL}/submit`;
  return makeRequest(finalURL, 'POST', payload);
};
